import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';

const local_language = localStorage.getItem('lang')

const ResetPasswordValidation: any = yup.object().shape({
    password: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("fjalëkalimin") : ValidationMessage.Field("password"))
        .min(8, local_language == "alb" ? ValidationMessageAlbanian?.MinLength('fjalëkalimin', 8) : ValidationMessage?.MinLength('Password', 8))
        .max(15, local_language == "alb" ? ValidationMessageAlbanian?.MaxLength('fjalëkalimin', 15) : ValidationMessage?.MaxLength('Password', 15))
        .matches(/^\S*$/, local_language == "alb" ? ValidationMessageAlbanian?.NO_SPACE_ALLOWED : ValidationMessage?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, local_language == "alb" ? ValidationMessageAlbanian?.PASSWORD_UPPER_CASE : ValidationMessage?.PASSWORD_UPPER_CASE),

    confirm_password: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("konfirmoni fjalëkalimin") : ValidationMessage.Field("confirm password"))
        .min(8, local_language == "alb" ? ValidationMessageAlbanian?.MinLength('Konfirmo fjalëkalimin', 8) : ValidationMessage?.MinLength('Confirm password', 8))
        .max(15, local_language == "alb" ? ValidationMessageAlbanian?.MaxLength('Konfirmo fjalëkalimin', 15) : ValidationMessage?.MaxLength('Confirm password', 15))
        .oneOf([yup.ref('password')], local_language == "alb" ? ValidationMessageAlbanian?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH : ValidationMessage?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),

});

export default ResetPasswordValidation;

